module.exports = __webpack_public_path__ + "img/PL00247.87878bff.png";